<template>
    <v-select
            class="ml-3 mr-3"
            :items="activities"
            :label="$tc('Activity')"
            :item-text="'name'"
            :item-value="'pk'"
            :loading="activitiesAreLoading"
            v-model="selectedActivityPkForVModel"
            v-on:change="setActivity()"
            outlined
            :disabled="disableComponent"
    ></v-select>
</template>
<script lang="ts">
    import {mapGetters, mapMutations, mapState} from "vuex";
    import axios from "axios";

    export default {
        name: 'activity-select',
        props: {
            disableComponent: Boolean,
        },
        computed: {
            ...mapGetters('common', [
                'serverURL',
            ]),
            ...mapState('common', [
                'selectedArea',
                'selectedActivity',
                'selectedActivityPk',
                'activitiesAreLoading',
                'activities',
            ]),
            // We must have a local property with a getter and setter
            // since Vuex does not allow setting state directly (mutations must be used)
            selectedActivityPkForVModel: {
                get: function () {
                    return this.selectedActivityPk;
                },
                set: function (newValue) {
                    this.setSelectedActivityPk(newValue);
                }
            },
        },
        methods: {
            ...mapMutations({
                setSelectedActivity: 'common/setSelectedActivity',
                setSelectedActivityPk: 'common/setSelectedActivityPk',
            }),
            setActivity() {
                axios
                    .put(this.serverURL +  '/set_selected_activity/'
                        , {'activity_pk': this.selectedActivityPk}
                    )
                    .then(() => {
                        let newActivity = this.activities.find(activity => activity.pk == this.selectedActivityPk);
                        this.setSelectedActivity(newActivity);
                    })
                    .catch((error) => {
                        console.log(error);
                        // Return to previous selection
                        this.setSelectedActivityPk(this.selectedActivity.pk);
                    });
            },
        },
    }
</script>